import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

export const Route = createFileRoute('/_legacy/entities/$')({
  validateSearch: z.object({
    entity: z.number(),
  }),
  // This will redirect from `/entities/:subTabName?entity=:entityId
  // to `/entity/:entityId/:subTabName.
  beforeLoad: ({ search: { entity }, params: { _splat: subTabName } }) => {
    const newPath = `/entity/${entity}${subTabName ? `/${subTabName}` : ''}`
    throw redirect({ to: newPath, replace: true })
  },
})
